import styled, { keyframes } from 'styled-components';
import { Theme } from 'styles/DefaultTheme';

const TableSkeleton = () => {
	return (
		<SkeletonBox>
			<Profile>
				<ProfileCircle />
				<ProfileRight>
					<Box _width="100%" _height="24px" />
					<Box _width="100px" _height="16px" />
				</ProfileRight>
			</Profile>
			<Box
				_width="96px"
				_height="24px"
				radius="100px"
				delay="0.2s"
				_margin="0 0 0 189px"
			/>

			<Box _width="80px" _height="21px" _margin="0 0 0 64px" delay="0.4s" />
			<Box _width="57px" _height="21px" _margin="0 0 0 64px" delay="0.6s" />
			<Box _width="57px" _height="21px" _margin="0 0 0 43px" delay="0.8s" />
			<Box _width="57px" _height="21px" _margin="0 0 0 43px" delay="1.0s" />
			<Box _width="57px" _height="21px" _margin="0 0 0 43px" delay="1.2s" />
			<Box _width="150px" _height="21px" _margin="0 0 0 60px" delay="1.4s" />
			<Box _width="80px" _height="21px" _margin="0 0 0 43px" delay="1.6s" />
		</SkeletonBox>
	);
};

const skeleton_ani = keyframes`
    0% {
      background-color: ${Theme.colors.gray.gray10};
    }
    50% {
      background-color: ${Theme.colors.gray.gray15};
    }
    100% {
      background-color: ${Theme.colors.gray.gray10};
    }
`;

const SkeletonBox = styled.div`
	width: calc(100% - 32px);
	height: 65px;
	border-radius: 8px;
	border: 1px solid ${({ theme }) => theme.colors.gray.gray15};
	margin-top: 8px;
	padding: 32px 16px;
	overflow: hidden;

	${({ theme }) => theme.common.flexStart};
`;

const CheckBox = styled.div`
	width: 24px;
	height: 24px;
	border-radius: 8px;
	border: 1px solid ${({ theme }) => theme.colors.gray.gray15};
	flex-shrink: 0;
`;
const Profile = styled.div`
	width: 272px;
	padding-left: 96px;
	${({ theme }) => theme.common.flexBetween}
`;
const ProfileCircle = styled.div`
	width: 32px;
	height: 32px;
	flex-shrink: 0;
	border-radius: 50%;
	background-color: ${({ theme }) => theme.colors.gray.gray10};
	animation: ${skeleton_ani} 6s infinite ease-in-out;
`;
const ProfileRight = styled.div`
	width: 152px;
	height: 48px;
	margin-left: 30px;
	padding: 2px 0;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

const MiddleSection = styled.div`
	height: 100%;
	flex-grow: 1;
	margin-left: 88px;
	${({ theme }) => theme.common.flexStart};
`;

const Box = styled.div<{
	_width: string;
	_height: string;
	radius?: string;
	_margin?: string;
	delay?: string;
}>`
	width: ${({ _width }) => _width};
	height: ${({ _height }) => _height};
	flex-shrink: 0;
	${({ radius }) => radius && `border-radius: ${radius}`};
	${({ _margin }) => _margin && `margin: ${_margin}`};
	background-color: ${({ theme }) => theme.colors.gray.gray10};
	animation: ${skeleton_ani} 6s infinite ease-in-out;
	${({ delay }) => delay && `animation-delay: ${delay}`};
`;

export default TableSkeleton;
